
import Vue, { PropType } from 'vue';
import ImageThumbnail from './ImageThumbnail.vue';
import InfoNotification from '../InfoNotification/InfoNotification.vue';
import { CvRow, CvColumn } from '@carbon/vue';
import { SearchedArtwork } from '../typings';

export default Vue.extend({
  components: {
    ImageThumbnail,
    CvRow,
    CvColumn,
    InfoNotification,
  },
  model: {
    prop: 'selectedItemId',
    event: 'update:selected-item-id',
  },
  props: {
    items: {
      type: [] as PropType<SearchedArtwork[]>,
      required: true,
    },
    selectedItemId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isNotificationVisible: true,
    };
  },
  computed: {
    infoNotificationSubtitle(): string {
      if (this.isThereOneNotUsedImproved) {
        return `${this.$i18n.t(
          'section.actions.new-improved-logo-subtitle-part-1'
        )} ${
          this.items.filter((x) => x.fileName.includes('_improved'))[0].title
        }. ${this.$i18n.t(
          'section.actions.new-improved-logo-subtitle-part-2'
        )}`;
      } else if (this.isThereManyNotUsedImproved) {
        return `${this.$i18n.t(
          'section.actions.new-improved-logo-subtitle-part-3'
        )} ${this.$i18n.t(
          'section.actions.new-improved-logo-subtitle-part-2'
        )}`;
      } else {
        return '';
      }
    },
    isThereAnyNotUsedImproved(): boolean {
      return this.isThereOneNotUsedImproved || this.isThereManyNotUsedImproved;
    },
    isThereOneNotUsedImproved(): boolean {
      return this.items
        ? this.items.filter(
            (x) => x.fileName.includes('_improved') && !x.isUsed
          ).length === 1
        : false;
    },
    isThereManyNotUsedImproved(): boolean {
      return this.items
        ? this.items.filter(
            (x) => x.fileName.includes('_improved') && !x.isUsed
          ).length > 1
        : false;
    },
  },
});
